"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var endpoint = 'wss://ws.realsee.com';
exports.default = endpoint;
//# sourceMappingURL=defaultWsEndpoint.js.map